import React, { useState } from 'react';
import '../styles/Navbar.css';
import appLogo from '../assets/app-icon.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { loggedIn, loading, logout, user } = useAuth();
  const navigate = useNavigate();
  const toggleMenu = () => setMenuOpen(prev => !prev);
  const handleLogout = async () => {
    logout(() => navigate('/login'));
  };

  return (
    <nav className='nav'>
      <div className='logo-container'>
        <img src={appLogo} alt="App Logo" className="app-logo" />
        <span>SoulfulYatra</span>
      </div>

      <div className="menu-toggle" onClick={toggleMenu}>
        &#9776;
      </div>

      <ul className={menuOpen ? 'show' : ''}>
        <li><Link to='/home'>Home</Link></li>
        {/*<li><Link to='/explore-places'>Explore Places</Link></li>
        <li><Link to='/plan-trip'>Plan a Trip</Link></li>
        <li><Link to='/hotel-rooms'>Hotel Rooms</Link></li>
        <li><Link to='/restaurants'>Restaurants</Link></li>*/}
        <li><Link to='/dashboard'>Dashboard</Link></li>
        <li><Link to='/vlogs'>Vlogs</Link></li>
        <li><Link to='/profile'>Profile</Link></li>
        {user?.role === "guide" && <li><Link to='/guide-dashboard'>Your Dashboard</Link></li>}
        <li>
          {loading ? (
            <span className="loading-text">Loading...</span>
          ) : loggedIn ? (
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          ) : (
            <Link to='/login'>Login</Link>
          )}
        </li>
      </ul>

    </nav>
  );
}
